module.exports = __webpack_public_path__ + "img/3.4abd7e6a.png";